import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathLessThan: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-less-than, <"><path fillRule="evenodd" clipRule="evenodd" d="M18.9412 6.45977C18.7808 6.07787 18.3412 5.89831 17.9593 6.05871L5.45933 11.3087C5.18089 11.4257 4.99976 11.6982 4.99976 12.0002C4.99976 12.3022 5.18089 12.5747 5.45933 12.6917L17.9593 17.9417C18.3412 18.1021 18.7808 17.9225 18.9412 17.5406C19.1016 17.1587 18.9221 16.7191 18.5402 16.5587L7.68658 12.0002L18.5402 7.44168C18.9221 7.28128 19.1016 6.84167 18.9412 6.45977Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMathLessThan;
